import { screen } from './react-testing-library'
import { withMarkup } from './withMarkup'

export * from './createRouteComponentProps'
export * from './mocks'
export * from './mockAdapter'
export * from './react-testing-library'
export * from './user-event-testing-library'
export * from './getResponseObject'
export * from './expectBackendToWork'
export * from './expectHistoryUrl'
export * from './mockGenericApiAdaptor'
export * from './withMarkup'
export * from './intlFormatHookMocks'
export * from './queryClient'
export * from './entitlementTestUtils'
export * from './queryByAnalyticsId'

export const getByTextWithMarkup = withMarkup(screen.getByText)
export const queryByTextWithMarkup = withMarkup(screen.queryByText)

export {
  fireSelectEvent,
  isSelectDisabled,
  isSelectOptionDisabled,
} from '@procurify/ui'
